<template>
  <!--  <div>{{ $route.params.id }}</div>-->
  <div class="application-info-container">
    <div class="application-info-top">
      <div class="container">
        <div class="application-info-top-header">采购申请信息</div>
        <div class="application-info-top-content-container">
          <el-form :inline="true" style="width: 100%" label-width="150px">
            <el-row style="margin-bottom: 0">
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="物料编码："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.apimaterNo }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="物料名称："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.prodname }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0">
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="采购数量："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{
                    Number(purchaseInfo.remainingQuantity) > 0
                      ? purchaseInfo.remainingQuantity
                      : purchaseInfo.intqty
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="要求交货日期："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.arriveTimeTxt }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-bottom: 0">
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="要求交货日期："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.arriveTimeTxt }}
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="仓储地点："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.conaddr }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" style="margin-bottom: 0">
                <el-form-item
                  label="采购申请计量单位："
                  class="base-detail"
                  style="margin-bottom: 0"
                >
                  {{ purchaseInfo.unit }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="flex-all-center" style="margin-left: -40px">
            <eui-btn font-size="12px" @click="goEnquiry">发起询价</eui-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="application-info-middle">
        <div class="application-info-middle-header">
          <div>商品选择</div>
          <div>
            根据筛选条件，为贵公司推荐
            <span>{{ queryParams.total }}</span>
            件商品
          </div>
        </div>
        <div class="wrapper">
          <e-search
            :data="filterInfo.data"
            :field-list="filterInfo.fieldList"
            @handleFilter="handleFilter"
            @handleReset="handleReset"
          ></e-search>
        </div>
      </div>
      <div>
        <!-- <div class="application-info-checkbox flex-start">
          <el-checkbox-group
            v-model="checkSearchList"
            class="flex-start"
            @change="onSearchChecked"
          >
            <el-checkbox label="centralizedSign">
              <img
                class="checkbox-icon"
                src="@/assets/img/product/together-buy@2x.png"
                alt="集采优品"
              />
            </el-checkbox>
            <el-checkbox label="tags">推荐商品</el-checkbox>
            <el-checkbox label="recommendSign">惠享优品</el-checkbox>
          </el-checkbox-group>
        </div> -->
        <div>
          <listFilter
            :list-filter-data="listFilterData"
            :check-list="checkList"
            @tabChangeHandle="changeHandle"
            @sortByPrice="sortByPrice"
            @selectCheckBox="handleTagSearch"
          ></listFilter>
        </div>
        <div class="application-info-bottom">
          <el-table
            :header-cell-style="{ color: '#333', background: '#f5f5f5' }"
            :data="productList"
            style="width: 100%"
          >
            <el-table-column align="center" prop="date" label="商品信息">
              <template slot-scope="scope">
                <div class="product-info">
                  <!-- <img class="product-img" :src="scope.row.defaultimage" alt /> -->
                  <div
                    class="p-img-wrap"
                    @click="
                      toDetail(scope.row.skuid, scope.row.suppliercompanyid)
                    "
                  >
                    <img
                      v-show="
                        scope.row.tagsList != undefined &&
                        scope.row.tagsList.indexOf('推荐') != -1
                          ? true
                          : false
                      "
                      class="p-tag"
                      src="@/assets/img/product/icon-product-good@2x.png"
                      alt
                    />
                    <img
                      :key="scope.row.skuid"
                      :src="scope.row.defaultimage"
                      class="p-img"
                      alt
                    />
                  </div>
                  <div class="product-info-right">
                    <div
                      v-if="scope.row.skuname.length < 48"
                      class="title two-line"
                    >
                      {{ scope.row.skuname }}
                    </div>
                    <el-tooltip
                      v-else
                      class="item"
                      effect="dark"
                      :content="scope.row.skuname"
                      placement="top"
                    >
                      <div class="title two-line">{{ scope.row.skuname }}</div>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.skucode"
                      placement="bottom"
                    >
                      <div class="num break">
                        单品编号：{{ scope.row.skucode }}
                      </div>
                    </el-tooltip>
                    <div class="provider">
                      供应商：{{ scope.row.suppliercompanyname }}
                    </div>
                    <!--                <div class="footer">-->
                    <!--                  <p class="authenticated">已认证</p>-->
                    <!--                  <p class="easy-all-pass">易权通</p>-->
                    <!--                </div>-->
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="brandname"
              label="品牌"
              width="150"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="delivertime"
              label="发货时间"
              width="150"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.delivertime }}天内发货</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="unitvalue"
              label="单位"
              width="100px"
            ></el-table-column>
            <el-table-column
              align="center"
              label="含税价格（元）"
              width="200px"
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.price && Number(scope.row.pricetype) === 4"
                  class="jc-price-container"
                >
                  <img
                    height="20px"
                    width="44px"
                    src="../../../../assets/img/product/jc-icon@2x.png"
                    alt="集采"
                  />
                  <div class="jc-price">
                    ￥<span>{{ moneyToFixed(scope.row.price) }}</span>
                  </div>
                </div>
                <div v-else>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      v-if="scope.row.pricetypedescribe === '惠享价'"
                      src="@/assets/img/purchase/good-price-icon.png"
                      alt=""
                      class="enjoy-price"
                    />
                    <span style="color: #f0250f; font-weight: bold"
                      >￥{{ moneyToFixed(scope.row.price) }}</span
                    >
                  </div>
                  <div
                    v-if="scope.row.priceList && scope.row.priceList.length > 0"
                    class="step-price"
                    @mouseover="
                      isShowPriceSheet = true;
                      isCurrent = scope.row.productid;
                    "
                    @mouseleave="
                      isShowPriceSheet = false;
                      isCurrent = null;
                    "
                  >
                    <img
                      src="../../../../assets/img/purchase/icon-stage-price@2x.png"
                      alt=""
                    />
                    <span class="icon-question">?</span>
                    <transition name="fade">
                      <priceSheet
                        v-if="
                          isShowPriceSheet && isCurrent == scope.row.productid
                        "
                        :price-table="scope.row.priceList"
                        :left="left"
                        :top="top"
                      ></priceSheet>
                    </transition>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100px">
              <template slot-scope="scope">
                <!-- <div class="select-btn" @click="selectBtn(scope.row)">选中</div> -->
                <eui-btn
                  type="text"
                  font-size="12px"
                  @click="selectBtn(scope.row)"
                  >选中</eui-btn
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <e-pager
      style="margin-top: 20px"
      :page-index="queryParams.pageNum"
      :total="queryParams.total"
      :page-size="queryParams.pageSize"
      @change="handleCurrentChange"
    ></e-pager> -->
      <div class="pagination-box">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryParams.pageNum"
          :total="queryParams.total"
          :page-size.sync="queryParams.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 还未维护计量单位提示 -->
    <e-dialog
      :dialog-title="dialogTitle"
      :dialog-type="''"
      :center-dialog-visible="unitVisible"
      :popup-width="'450px'"
      :show-close="false"
      @submitPopupData="submitPopupData"
      @updateVisible="unitVisible = false"
      @resetPopupData="unitVisible = false"
    >
      <div>您好，所选商品计量单位关系转换还未维护，是否手工维护？</div>
    </e-dialog>
    <!-- 新增计量单位 -->
    <e-dialog
      :dialog-title="addDialogTitle"
      :dialog-type="''"
      :center-dialog-visible="addUnitVisible"
      :popup-width="'500px'"
      :show-close="false"
      @submitPopupData="addPopupData('form')"
      @resetPopupData="handleClose"
    >
      <el-form ref="form" :rules="rules" :model="unitForm" label-width="130px">
        <el-form-item label="采购商计量单位：">
          <el-input v-model="unitForm.purchaseUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="易派客计量单位：">
          <el-input v-model="unitForm.epecUnit" disabled></el-input>
        </el-form-item>
        <el-form-item label="转换比例：" prop="proportion">
          <div class="proportion-unit">
            {{ `(${unitForm.purchaseUnit}：${unitForm.epecUnit})` }}
          </div>
          <el-input
            v-model="unitForm.proportion"
            autocomplete="off"
            clearable
            placeholder="请输入转换比例"
            @blur="blurInput($event)"
            @input="limitInput($event, 'proportion')"
          ></el-input>
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import priceSheet from '@/modules/projectA/components/purchase/pirce-sheet.vue';
import Api from '@/modules/projectA/api/purchase';
import enApi from '@/modules/projectA/api/enquiry';
import eSearch from '../../components/common/e-search';
import listFilter from './components/listFilter.vue';
// const qs = require('qs');

export default {
  components: { eDialog, priceSheet, eSearch, listFilter },
  data() {
    return {
      filterInfo: {
        data: {
          companyName: null,
          skuname: null,
          skucode: null,
          queryBrandname: null,
        },
        fieldList: [
          { label: '供应商名称', type: 'input', value: 'companyName' },
          { label: '商品名称', type: 'input', value: 'skuname' },
          { label: '商品编码', type: 'input', value: 'skucode' },
          { label: '品牌', type: 'input', value: 'queryBrandname' },
        ],
      },
      isShowPriceSheet: false,
      isCurrent: null,
      top: '-38px',
      left: '-530px',
      searchValue: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      formLabelAlign: {
        name: '',
        region: '',
        type: '',
        test: '',
      },
      unitForm: {
        purchaseUnit: '',
        epecUnit: '',
        proportion: '',
      },
      prItemId: '',
      productList: [],
      productSearch: {
        companyName: null,
        // skuname: null,
        // skucode: null,
        queryBrandname: null,
        skuname: '', // 精确查询
        searchtext: '', // 模糊查询
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        unitvalue: '', // 筛选条件
        centralizedSign: '', // 集采优品  选中传 1
        tags: [], // 推荐商品 选中传 [1]
        recommendSign: 0, // 惠享优品 选中传 1
        pageNum: 1,
        pageSize: 10,
      },
      purchaseInfo: Object,
      oldSkuIdList: [],
      prPurchasLlistVOs: [],
      dialogTitle: '计量单位关系转换',
      addDialogTitle: '新增计量单位转换',
      unitVisible: false,
      addUnitVisible: false,
      rules: {
        proportion: [
          { required: true, message: '请输入转换比例', trigger: 'blur' },
        ],
      },
      checkSearchList: [], // 商品列表筛选复选框
      listFilterData: {},
      checkList: [],
    };
  },
  mounted() {
    this.prItemId = this.$route.query.prItemId;
    // this.productSearch.skuname = this.$route.query.prodname;
    this.queryPurchaseRequestDetail();
  },
  methods: {
    sortByPrice(options, type) {
      this.queryParams.pageNum = 1;
      if (type === 'price') {
        this.queryParams.orderBy = 'price';
        this.queryParams.ranking = options;
      } else if (type === 'area') {
        this.queryParams.pageNum = 1;
        this.queryParams.areacode = options;
      }
      this.queryProductPage();
    },
    changeHandle(options) {
      this.queryParams.pageNum = 1;
      if (options === '默认') {
        this.queryParams.orderBy = null;
        this.queryParams.ranking = null;
        this.queryProductPage();
      } else if (options === '销量') {
        this.queryParams.orderBy = 'salesvolume';
        this.queryParams.ranking = '2';
        this.queryProductPage();
      } else if (options === '产品质量评价') {
        this.queryParams.orderBy = 'productevaluate';
        this.queryParams.ranking = '2';
        this.queryProductPage();
      }
    },
    // 优选、认证、易权通标识搜索
    async handleTagSearch(options) {
      console.log(options);
      this.queryParams.pageNum = 1;
      if (options.indexOf(1) != -1) {
        // 推荐商品
        this.queryParams.tags = [1];
      } else {
        this.queryParams.tags = [];
      }
      if (options.indexOf(2) != -1) {
        // 集采商品
        this.queryParams.centralizedSign = 1;
      } else {
        this.queryParams.centralizedSign = '';
      }
      if (options.indexOf(3) != -1) {
        // 可用易权通
        this.queryParams.ebillsign = 1;
      } else {
        this.queryParams.ebillsign = '';
      }
      if (options.indexOf(6) > -1) {
        // 优品推荐
        this.queryParams.recommendSign = 1;
      } else {
        this.queryParams.recommendSign = 0;
      }
      if (options.indexOf(7) > -1) {
        // 非标商品
        this.queryParams.datafrom = 2;
      } else {
        this.queryParams.datafrom = '';
      }
      if (options.indexOf(8) > -1) {
        // 非标商品
        this.queryParams.stockSign = 1;
      } else {
        this.queryParams.stockSign = '';
      }
      // if (this.routeData.from === 'sales') {
      //   let tagList = await this.queryTagLabelList();
      //   let index = utils.getArgumentIndexInAttr(tagList, 'tagTextLabel', this.routeData.searchValue);
      //   this.queryParams.tags.push(tagList[index].tagTextLabelId);
      // }
      // this.isSearchBtn = false;
      this.queryProductPage();
    },
    // 商品筛选
    onSearchChecked(value) {
      const checked = {
        centralizedSign: value.includes('centralizedSign') ? 1 : '',
        tags: value.includes('tags') ? [1] : [],
        recommendSign: value.includes('recommendSign') ? 1 : 0,
        pageNum: 1,
      };
      this.queryParams.pageNum = 1;
      this.productSearch = { ...this.productSearch, ...checked };
      this.queryProductPage();
    },
    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    handleFilter(val) {
      this.productSearch.companyName = val.companyName;
      this.productSearch.skuname = val.skuname;
      this.productSearch.skucode = val.skucode;
      this.productSearch.queryBrandname = val.queryBrandname;
      this.queryParams.pageNum = 1;
      this.queryPurchaseRequestDetail();
    },
    handleReset() {
      this.productSearch.companyName = null;
      this.productSearch.skuname = null;
      this.productSearch.skucode = null;
      this.productSearch.queryBrandname = null;
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.queryPurchaseRequestDetail();
    },
    goEnquiry() {
      this.$router.push({
        path: '/enquiryManage/enquiryIss',
        query: {
          prItemId: this.prItemId,
          type: 'integrated',
        },
      });
    },
    // 搜索
    goToSearch() {
      if (this.searchValue.trim() === '') {
        this.$message.warning('请输入搜索词');
        return;
      }
      if (this.searchValue.trim().length > 100) {
        this.$message.warning('搜索词不能超过100个字');
        return;
      }
      this.productSearch.searchtext = this.searchValue;
      this.queryParams.pageNum = 1;
      this.queryProductPage();
    },
    resetBtn() {
      this.productSearch = {
        skuname: '',
        brandname: '', // 品牌
        skucode: '', // 商品编号
        specificationstr: '', // 规格属性
        companyName: '', // 供应商
        // unitvalue: this.purchaseInfo.epecBaseUnitName ?  this.purchaseInfo.epecBaseUnitName :'',
        unitvalue: '',
        pageNum: 1,
        pageSize: 10,
      };
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.queryProductPage();
    },
    handleSizeChange(val) {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = val;
      this.queryProductPage();
    },
    onSubmit() {},
    async queryPurchaseRequestDetail() {
      const res = await Api.queryPurchaseRequestDetail({
        prItemId: this.prItemId,
      });
      if (res.code === '200') {
        this.purchaseInfo = res.data;
        //  if(res.data.epecBaseUnitName){
        //    this.productSearch.unitvalue = res.data.epecBaseUnitName;
        //  }
      }
      this.queryProductPage();
    },
    async queryProductPage() {
      this.productSearch.isPurchaseControl =
        Number(this.$store.state.isProtocol) === 62 ? 1 : 0;
      const res = await enApi.queryProductPage({
        ...this.productSearch,
        ...this.queryParams,
      });
      if (res.code === '200') {
        this.productList = res.data.list;
        this.queryParams.total = res.data.total;
      }
      const stepReq = [];
      // 封装阶梯价 数据
      this.productList.forEach((item) => {
        stepReq.push({
          supplierCompanyId: item.suppliercompanyid,
          skuId: item.skuid,
        });
      });
      const stepRes = await Api.getStepPrice(stepReq); // 获取阶梯价
      if (stepRes.code === 200) {
        const stepData = stepRes.data;
        const arr = ['阶梯价', '市场价']; // 区分价格展示 先后 协议价 惠享价 阶梯价 市场价;
        this.productList.forEach((item) => {
          if (arr.includes(item.pricetypedescribe)) {
            stepData.forEach((stepItem) => {
              if (item.skuid === stepItem.skuId) {
                this.$set(item, 'priceList', stepItem.stepPriceList);
                // item.priceList = stepItem.stepPriceList ;
              }
            });
          }
        });
      }
    },
    // 选中 参考
    async selectProduct(data) {
      this.unitForm.purchaseUnit = this.purchaseInfo.unit;
      this.unitForm.epecUnit = data.unitvalue;
      const rateInfo = await Api.getProductRate({
        taxRateId: data.taxrateid,
      });
      const params = {
        prItemId: this.prItemId,
        baseUnitName: data.unitvalue,
        baseUnitNo: data.unitId, // 单位id
        brandName: data.brandname,
        categoryId: data.thirdcategorycode, // 类目id
        categoryName: data.thirdcategory, // 类目名称
        convertNumber: 1,
        goodsUnitName: data.unitvalue,
        goodsUnitNo: data.unitId,
        inherentPropertyAOList: data.attributesList
          ? this.assembleCartParams(
              data.attributesList,
              'inherentPropertyName',
              'inherentPropertyValue'
            )
          : [],
        materNo: '',
        price: data.price,
        productId: data.productid,
        productName: data.skuname,
        productPictUrl: data.defaultimage,
        productSkuCode: data.skucode, // 单品编号
        productSkuId: data.skuid, // 单品id
        productTypeId: '',
        productTypeName: '',
        quantity: 1,
        salesPropertyInfoAOList: data.specificationsList
          ? this.assembleCartParams(
              data.specificationsList,
              'salesPropertyInfoName',
              'salesPropertyInfoValue'
            )
          : [],
        salesTaxNo: rateInfo.data.taxRateCode, // 税率
        salesTaxRate: parseFloat(rateInfo.data.taxRate), // 税码
        sinoProtocol: '', // 协议号
        skuOptions: data.specifications,
        supplierCompany: data.suppliercompanyname,
        supplierCompanyId: data.suppliercompanyid,
        // tax:,//没有字段
        taxName: rateInfo.data.taxRateDes, // 可以为空
      };

      if (data.pricetype === 4) {
        const paramsData = {
          supplierCompanyId: data.suppliercompanyid,
          skuId: data.skuid,
          priceType: 4,
        };
        const result = await Api.queryAgreementCodeByType(paramsData);
        if (result.success) {
          const [newAgreementCode] = result.data;
          params.sinoProtocol = newAgreementCode;
          params.protocolCode = newAgreementCode;
          params.pricetype = 4;
        }
      }
      const res = await Api.selectProduct(params);
      if (res.code === '200') {
        this.$message.success('商品成功选中');
        this.$router.push('/myPurchaseRequest');
      } else if (res.code === '4089') {
        this.unitVisible = true;
      }
    },
    // 组装加入购物车规格属性参数
    assembleCartParams(arr, name, value) {
      // console.log(arr);
      const res = [];
      if (arr.length === 0) return res;
      for (let i = 0; i < arr.length; i++) {
        const temObj = {};
        const index = arr[i].indexOf('_');
        temObj[name] = arr[i].substr(0, index);
        temObj[value] = arr[i].substr(index + 1);
        res.push(temObj);
      }
      // console.log(res);
      return res;
    },
    changePriceSheetShow(index) {
      this.$set(this.productList[index], this.isShowPriceSheet, true);
    },
    changePriceSheetHidden(index) {
      this.$set(this.productList[index], this.isShowPriceSheet, false);
    },
    selectBtn(data) {
      this.selectProduct(data);
    },

    // 手动维护计量单位
    submitPopupData() {
      this.unitVisible = false;
      this.addUnitVisible = true;
    },

    handleClose() {
      this.addUnitVisible = false;
      this.$refs.form.resetFields();
    },

    blurInput(e) {
      const val = e.target.value;
      if (val === 0) {
        this.unitForm.proportion = '';
      }
    },
    limitInput(value, name) {
      this.unitForm[name] =
        `${value}` // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, '') // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, '$1') // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, '0.') // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,4})/g)[0] || ''; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到4位小数
    },
    // 新增计量单位转换
    addPopupData(form) {
      const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
      // eslint-disable-next-line consistent-return
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const params = {
            sourceUnit: this.unitForm.purchaseUnit,
            targetUnit: this.unitForm.epecUnit,
            conversionRatio: this.unitForm.proportion,
            companyId: userInfo.companyId,
            companyName: userInfo.companyName,
            sysNo: userInfo.internalCode,
          };
          Api.addConversionUnit(params).then((res) => {
            if (res.code === '200') {
              this.addUnitVisible = false;
              this.$message.success('提交成功');
              this.queryPurchaseRequestDetail();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/assets/css/theme.scss';
.application-info-container {
  color: $font-color-text;
  margin-bottom: 20px;
  ::v-deep .el-input__inner {
    color: #333;
  }
  .jc-price-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    img {
      position: relative;
      z-index: 1;
    }
    .jc-price {
      height: 18px;
      padding: 0 10px 0 20px;
      margin-left: -20px;
      align-self: flex-end;
      background: #ffeac9;
      line-height: 18px;
      font-size: 14px;
      font-weight: 400;
      border-radius: 4px;
      color: #f0250f;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .enjoy-price {
    width: 45px;
    height: 16px;
  }
  .application-info-top {
    margin-bottom: 20px;

    .application-info-top-header {
      font-weight: bold;
      padding-left: 20px;
      height: 40px;
      border: 1px solid #d9d9d9;
      border-bottom: none;
      line-height: 40px;
      color: $font-color-text;
      background-color: $main-table-th-bg;
      box-sizing: border-box;
      font-size: 14px;
    }

    .application-info-top-content-container {
      display: flex;
      flex-direction: column;
      padding: 20px 20px 20px 60px;
      border: 1px solid $border-color;
      box-sizing: border-box;

      .application-info-top-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        > div {
          width: 300px;
          margin-bottom: 20px;
        }
      }
    }
  }
  .application-info-middle {
    margin-bottom: 20px;
    border: 1px solid $border-color;
    box-sizing: border-box;
    font-size: 14px;
    ::v-deep .el-input {
      width: 200px;
      border-radius: 0;
    }
    .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      .enquiry_btn {
        width: 100px;
        height: 34px;
        line-height: 30px;
        background: #2587ff;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border: 2px solid $main-col;
        &:hover {
          background-color: #126edf;
          border-color: #126edf;
        }
      }
    }

    .application-info-middle-header {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #d9d9d9;
      color: $font-color-text;
      background: $main-table-th-bg;
      box-sizing: border-box;

      div:nth-child(1) {
        font-weight: bold;
      }

      span {
        color: $headline-color-num;
      }
    }
    .scroller_right {
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      .scroller_input {
        width: 514px;
        ::v-deep.el-input__inner {
          border: 1px solid $main-col;
          border-right: none;
          border-radius: 0;
          height: 34px;
          line-height: 34px;
          font-size: 12px;
        }
      }
      .scroller_btn {
        width: 100px;
        height: 34px;
        line-height: 30px;
        background: #2587ff;
        text-align: center;
        cursor: pointer;
        color: #fff;
        border: 2px solid $main-col;
        &:hover {
          background-color: #126edf;
          border-color: #126edf;
        }
      }
    }
    .application-info-middle-content-container {
      display: flex;
      justify-content: space-between;
      padding: 20px 20px 0 38px;
      box-sizing: border-box;

      .application-info-middle-content-left {
        flex: 0 1 924px;

        ::v-deep .el-form {
          margin-top: -14px;
          .el-form-item {
            margin-bottom: 0;
            .el-form-item__content {
              .el-col {
                .el-input {
                  input {
                    width: 190px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
    .application-info-middle-content-right {
      display: flex;
      justify-content: center;
      margin: 7px 0 10px 0;
      .reset-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #e8efff;
        color: #2587ff;
        cursor: pointer;
        border: 1px solid #2587ff;
        margin-right: 20px;
        &:hover {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 30px;
        background: #2587ff;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background-color: #126edf;
        }
      }
    }
  }
  .flex-start {
    display: flex;
    align-items: center;
  }
  .application-info-checkbox {
    height: 44px;
    padding: 0px 10px;
    margin-bottom: 10px;
    border: 1px solid $border-color;
    background: #f5f5f5;
    color: #666666;

    ::v-deep .el-checkbox {
      display: flex;
      align-items: center;
      margin-right: 16px;

      .el-checkbox__label {
        line-height: 18px;
        padding-left: 6px;
      }
    }

    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #666666;
    }

    .checkbox-icon {
      width: 72px;
      height: 18px;
    }
  }
  .application-info-bottom {
    border: 1px solid #d9d9d9;
    box-sizing: border-box;

    ::v-deep .el-table {
      .product-info {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;

        .product-img {
          width: 88px;
          height: 88px;
          border: 1px solid #e2e2e2;
          box-sizing: border-box;
        }

        .product-img-icon {
          position: absolute;
          top: 11px;
          left: 6px;
          width: 20px;
          height: 20px;
        }

        .product-info-right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          > div {
            align-self: flex-start;
          }

          .title {
            width: 100%;
            text-align: left;
            color: #333333;
          }

          .num {
            font-size: 12px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 231px;
            text-align: left;
          }

          .provider {
            font-size: 12px;
            color: #666666;
          }

          .footer {
            display: flex;
            justify-content: flex-start;

            p {
              width: 48px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #ffffff;
              margin-left: 10px;
              border-radius: 5px;
              font-size: 12px;
            }

            .authenticated {
              background-color: $button-background-color;
            }

            .easy-all-pass {
              background-color: $button-background-color2;
            }
          }
        }
      }

      .select-btn {
        width: 80px;
        height: 30px;
        line-height: 26px;
        color: #2587ff;
        border: 1px solid #2587ff;
        background-color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #2587ff;
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-table .cell {
  overflow: visible;
}

.step-price {
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  &:hover {
    .price-sheet {
      display: inline-block;
    }
  }
  cursor: pointer;
  img {
    width: 45px;
    margin: 0 4px 0 8px;
  }
  .icon-question {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    .icon-question {
      background: #c5c5c5;
      color: #fff;
    }
  }
}
::v-deep .el-input__inner {
  border-radius: 0;
}
::v-deep .el-form-item__content {
  position: relative;
}
.proportion-unit {
  position: absolute;
  left: -140px;
  top: 28px;
  width: 120px;
  height: 30px;
  text-align: right;
  word-wrap: break-word;
  word-break: break-all;
  line-height: normal;
}
.pagination-box {
  text-align: right;
}
.p-img-wrap {
  position: relative;
  // border: 1px solid #d9d9d9;
  width: 88px;
  height: 88px;
  // margin-left: 10px;
  text-align: center;
  line-height: 88px;
  cursor: pointer;
  .p-tag {
    width: 20px;
    height: 25px;
    position: absolute;
    top: 0;
    left: 8px;
  }
  .p-img {
    width: 100%;
    height: 100%;
  }
  img[lazy='error'] {
    width: 40px !important;
    height: 28px !important;
  }
}
</style>
